import React, { useEffect, useRef } from 'react';
import { FadeIn } from './FadeIn';
export function Videos() {
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target as HTMLVideoElement;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, {
      threshold: 0.5
    });
    videoRefs.current.forEach(video => {
      if (video) observer.observe(video);
    });
    return () => {
      videoRefs.current.forEach(video => {
        if (video) observer.unobserve(video);
      });
    };
  }, []);
  return <section id="videos" className="py-[120px] px-[5%] bg-gradient-to-b from-gris-oscuro to-gris-medio" data-id="element-286">
      <FadeIn className="text-center mb-[70px]" data-id="element-287">
        <span className="inline-block bg-azul-neon/10 border border-azul-neon/30 text-acento text-[12px] font-semibold tracking-[2px] uppercase px-[16px] py-[6px] rounded-full mb-[18px]" data-id="element-288">
          Nuestro trabajo
        </span>
        <h2 className="font-rajdhani text-[clamp(32px,4vw,52px)] font-bold leading-[1.1] mb-[16px]" data-id="element-289">
          Lo Que <span className="text-acento" data-id="element-290">Hacemos</span>
        </h2>
        <p className="text-texto-gris text-[16px] max-w-[520px] mx-auto leading-[1.7]" data-id="element-291">
          Mirá nuestros trabajos reales, sin filtros.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-[24px] max-w-[1200px] mx-auto" data-id="element-292">
        {/* VIDEO 1 */}
        <FadeIn data-id="element-293">
          <div className="rounded-[14px] overflow-hidden border border-white/10 bg-gris-oscuro transition-all duration-300 aspect-[9/16] max-h-[500px] relative group hover:border-azul-neon/40 hover:scale-[1.02] hover:shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-294">
            <video ref={el => videoRefs.current[0] = el} controls playsInline muted poster="https://cdn.magicpatterns.com/uploads/mx4tizEehZCSrdMT8eyPYR/foto_1.jpg" className="w-full h-full object-cover" data-id="element-295">
              <source src="https://cdn.magicpatterns.com/uploads/xqGQF5UXQnNYuoW2BpFUQc/VIDEO 1.MOV" type="video/mp4" data-id="element-296" />
            </video>
            <div className="absolute bottom-0 left-0 right-0 p-[20px_16px_16px] bg-gradient-to-t from-black/85 to-transparent text-[14px] font-semibold pointer-events-none" data-id="element-297">
              Distribución & Amortiguadores
            </div>
          </div>
        </FadeIn>

        {/* VIDEO 2 */}
        <FadeIn delay={0.1} data-id="element-298">
          <div className="rounded-[14px] overflow-hidden border border-white/10 bg-gris-oscuro transition-all duration-300 aspect-[9/16] max-h-[500px] relative group hover:border-azul-neon/40 hover:scale-[1.02] hover:shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-299">
            <video ref={el => videoRefs.current[1] = el} controls playsInline muted className="w-full h-full object-cover" data-id="element-300">
              <source src="https://cdn.magicpatterns.com/uploads/nKUJ66kn3R65zbvC3VeP4F/VIDEO 2.MOV" type="video/mp4" data-id="element-301" />
            </video>
            <div className="absolute bottom-0 left-0 right-0 p-[20px_16px_16px] bg-gradient-to-t from-black/85 to-transparent text-[14px] font-semibold pointer-events-none" data-id="element-302">
              Motor Completo Peugeot
            </div>
          </div>
        </FadeIn>

        {/* VIDEO 3 (Using Image 2 as placeholder) */}
        <FadeIn delay={0.2} data-id="element-303">
          <div className="rounded-[14px] overflow-hidden border border-white/10 bg-gris-oscuro transition-all duration-300 aspect-[9/16] max-h-[500px] relative group hover:border-azul-neon/40 hover:scale-[1.02] hover:shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-304">
            <div className="w-full h-full min-h-[350px] flex flex-col items-center justify-center gap-[14px] bg-gris-medio rounded-[14px] relative" data-id="element-305">
              <img src="https://cdn.magicpatterns.com/uploads/qehLCfnahSiEVbQGEaT48o/quitale_el_coso_verde_ese_202605020108.jpg" alt="Cajas Automáticas" className="absolute inset-0 w-full h-full object-cover" data-id="element-306" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-[20px_16px_16px] bg-gradient-to-t from-black/85 to-transparent text-[14px] font-semibold pointer-events-none z-10" data-id="element-307">
              Cajas Automáticas
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}